import { notifyError } from "../../helpers/helpers";
import { auction } from "../config/urlConfig";

export const buyerTodayData =
  (currentPage, totalNumberRow, auctionFilter) => async (dispatch) => {
    const skip = (currentPage - 1) * totalNumberRow;
    dispatch({ type: "BUYER_TODAY_LOADING" });
    try {
      const { data } = await auction.get(
        `/auction/read/today-auctions?auctionType=${auctionFilter}&skip=${skip}&limit=${totalNumberRow}`
      );

      dispatch({ type: "BUYER_TODAY", payload: data });
    } catch (error) {
       notifyError(error.response ? error.response?.data : error.message,error.response?.status);
      dispatch({ type: "BUYER_TODAY_LOADDED" });
    }
  };

export const getTodayOffersAction = () => async (dispatch) => {
  dispatch({ type: "GETING_TODAY_OFFERS" });
  try {
    const { data } = await auction.get("/auction/read/today-offers");
    dispatch({ type: "GOT_TODAY_OFFERS", payload: data });
  } catch (error) {
    dispatch({ type: "CANNOT_GET_TODAY_OFFERS_LOADED" });
  }
};

export const buyerUpcomingData =
  (currentPage, totalNumberRow, auctionFilter) => async (dispatch) => {
    const skip = (currentPage - 1) * totalNumberRow;
    dispatch({ type: "BUYER_UPCOMING_LOADING" });
    try {
      const { data } = await auction.get(
        `/auction/read/upcoming-auctions?auctionType=${auctionFilter}&skip=${skip}&limit=${totalNumberRow}`
      );

      dispatch({ type: "BUYER_UPCOMING", payload: data });
    } catch (error) {
       notifyError(error.response ? error.response?.data : error.message,error.response?.status);
      dispatch({ type: "BUYER_UPCOMING_LOADDED" });
    }
  };

export const asidebuyerUpcomingData = () => async (dispatch) => {
  dispatch({ type: "BUYER_UPCOMING_LOADING_ASIDE" });
  try {
    await auction.get("/auction/read/upcoming-auctions").then((res) => {
      dispatch({ type: "BUYER_UPCOMING_ASIDE", payload: res?.data });
    });
  } catch (error) {
     notifyError(error.response ? error.response?.data : error.message,error.response?.status);
    dispatch({ type: "BUYER_UPCOMING_LOADDED_ASIDE" });
  }
};

export const getBuyerPaidEmd =
  (currentPage, totalNumberRow, auctionFilter) => async (dispatch) => {
    const skip = (currentPage - 1) * totalNumberRow;
    dispatch({ type: "BUYER_PAID_LOADING" });
    try {
      const { data } = await auction.get(
        `/auction/read/deposited-offers?auctionType=${auctionFilter}&skip=${skip}&limit=${totalNumberRow}`
      );
      dispatch({ type: "BUYER_PAID_EMD", payload: data });
    } catch (error) {
       notifyError(error.response ? error.response?.data : error.message,error.response?.status);
      dispatch({ type: "BUYER_PAID_LOADDED" });
    }
  };
